import { render, staticRenderFns } from "./TrainingRegistrationCourseCallout.vue?vue&type=template&id=2887e530&"
import script from "./TrainingRegistrationCourseCallout.vue?vue&type=script&lang=js&"
export * from "./TrainingRegistrationCourseCallout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports